import { Container, Grid, Link } from "@mui/material";
import React from "react";
const Footer = () => {
    return(
        <div className="py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                >
                    <Grid
                        xs={12}
                        sm={8}
                        lg={6}
                        className="text-center mt-4"
                    >
                        <Link href="#" className="d-inline-block mx-2 text-light">
                            Medium
                        </Link>
                        <Link href="#" className="d-inline-block mx-2 text-light">
                            CoinMarketCap
                        </Link>
                        <Link href="#" className="d-inline-block mx-2 text-light">
                            Coingecko
                        </Link>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default Footer;